/* Southern Diesel Supply - "Fits my truck" toggle for collection and search pages.
   Reads the saved truck (window.SDSVehicle), fetches that platform's product
   handles once (cached in sessionStorage), and hides product cards that are
   not in it. Applies to the cards on the current page. */
(function () {
  'use strict';
  var PREF = 'sds_fits_only';
  var cache = {};

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }

  function vehicle() { return window.SDSVehicle && window.SDSVehicle.get ? window.SDSVehicle.get() : null; }

  function load(handle) {
    if (cache[handle]) return cache[handle];
    var saved = store('sds_fits_' + handle);
    if (saved) { try { cache[handle] = Promise.resolve(new Set(JSON.parse(saved))); return cache[handle]; } catch (e) {} }
    cache[handle] = new Promise(function (resolve, reject) {
      var all = [];
      (function page(n) {
        fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n)
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (d) {
            var list = d.products || [];
            list.forEach(function (p) { all.push(p.handle); });
            if (list.length === 250 && n < 20) page(n + 1);
            else { store('sds_fits_' + handle, JSON.stringify(all)); resolve(new Set(all)); }
          })
          .catch(reject);
      })(1);
    });
    return cache[handle];
  }

  function bar() {
    var b = document.querySelector('[data-sds-fits-filter]');
    if (b) return b;
    var list = document.querySelector('product-list');
    if (!list) return null;
    b = document.createElement('label');
    b.setAttribute('data-sds-fits-filter', '');
    b.className = 'sds-fits-filter';
    b.hidden = true;
    b.innerHTML = '<input type="checkbox" data-sds-fits-box> <span data-sds-fits-label></span> <span class="sds-fits-filter__n" data-sds-fits-n></span>';
    var host = list.closest('reveal-items') || list;
    host.parentNode.insertBefore(b, host);
    b.querySelector('input').addEventListener('change', function (e) {
      store(PREF, e.target.checked ? '1' : '0');
      apply();
    });
    return b;
  }

  function apply() {
    var b = bar();
    if (!b) return;
    var v = vehicle();
    var cards = document.querySelectorAll('product-card');
    var box = b.querySelector('input');
    if (!v || !v.handle || !cards.length) {
      b.hidden = true;
      cards.forEach(function (c) { c.hidden = false; });
      return;
    }
    b.hidden = false;
    b.querySelector('[data-sds-fits-label]').textContent = 'Only show parts that fit my ' + v.label;
    box.checked = store(PREF) === '1';
    var n = b.querySelector('[data-sds-fits-n]');
    if (!box.checked) {
      cards.forEach(function (c) { c.hidden = false; });
      n.textContent = '';
      return;
    }
    load(v.handle).then(function (set) {
      var hidden = 0;
      document.querySelectorAll('product-card').forEach(function (c) {
        var fits = set.has(c.getAttribute('handle'));
        c.hidden = !fits;
        if (!fits) hidden++;
      });
      n.textContent = hidden ? '(' + hidden + ' hidden on this page)' : '';
    }).catch(function () { n.textContent = '(could not load fitment)'; box.checked = false; });
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(apply, 120); }

  function init() {
    apply();
    document.addEventListener('sds:vehicle-change', apply);
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].target.nodeName === 'PRODUCT-LIST' || (m[i].addedNodes.length && m[i].target.closest && m[i].target.closest('product-list'))) { soon(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
